import * as React from 'react';
import {Breadcrumb, Grid, Input} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    AdditionalDataServiceComponentProps,
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps, withAdditionalDataServices,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers,
    withPrintAndExport,
    withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import TourDataServiceSingleton from "../../services/TourDataService";
import Moment from "react-moment";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
import {GUARD_ADMIN, GUARD_FEATURESWITCH_ENABLED} from "../../routes";

import moment from "moment";
import _get from "lodash/get";
import {useCallback, useEffect, useMemo} from "react";
import ExportContextHolder from "../../../../lib/ExportContextHolder";
import authService from "../../services/AuthService";
import InventoryAccountModal from '../logistics/InventoryAccountModal';

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'data.dateTransaction',
        labelTranslationKey: 'TourData.TourDate',
        required: false,
        default: true,
        cellRender: v => <Moment format={t("Common.DateFormat")}>{v}</Moment>,
        printExportRender: v => moment(v).format(t("Common.DateFormat"))
    },
    {
        fieldName: 'data.transactionId',
        labelTranslationKey: 'TourData.TransactionId',
        required: false,
        default: false
    },
    {
        fieldName: 'data.transactionNumber',
        labelTranslationKey: 'TourData.TransactionNumber',
        required: false,
        default: true
    },
    {
        fieldName: 'data.contractorNumber',
        labelTranslationKey: 'TourData.ContractorNumber',
        required: false,
        default: true
    },
    {
        fieldName: 'data.contractorName',
        labelTranslationKey: 'TourData.ContractorName',
        required: false,
        default: false
    },
    {
        fieldName: 'data.depotNumber',
        labelTranslationKey: 'TourData.DepotNumber',
        required: false,
        default: true,
        cellRender: (v,r) => v + ", " + r.data.depotName,
        printExportRender: (v,r) => v + ", " + r.data.depotName
    },
    {
        fieldName: 'data.depotNumberCounterpart',
        labelTranslationKey: 'TourData.DepotNumberCounterpart',
        required: false,
        default: true,
        cellRender: (v,r) => v + ", " + r.data.depotNameCounterpart,
        printExportRender: (v,r) => v + ", " + r.data.depotNameCounterpart
    },
    {
        fieldName: 'data.transactionFileNumber',
        labelTranslationKey: 'TourData.TransactionFileNumber',
        required: false,
        default: true
    },
    {
        fieldName: 'data.transporterNumber',
        labelTranslationKey: 'TourData.TransporterNumber',
        required: false,
        default: true
    },
    {
        fieldName: 'data.transporterName',
        labelTranslationKey: 'TourData.TransporterName',
        required: false,
        default: true
    },
    {
        fieldName: 'data.documentNumber',
        labelTranslationKey: 'TourData.DocumentNumber',
        required: false,
        default: false
    },
    {
        fieldName: 'data.transactionFlowTypeNumber',
        labelTranslationKey: 'TourData.TransactionFlowTypeNumber',
        required: false,
        cellAlign: 'right',
    },
    {
        fieldName: 'data.transactionFlowTypeName',
        labelTranslationKey: 'TourData.TransactionFlowTypeName',
        required: false,
        cellAlign: 'right',
        default: false
    },
    {
        fieldName: 'data.statusId',
        labelTranslationKey: 'TourData.StatusId',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'data.status',
        labelTranslationKey: 'TourData.Status',
        required: false,
        cellAlign: 'right',
        default: false
    },
    {
        fieldName: 'data.transactionTypeId',
        labelTranslationKey: 'TourData.TransactionTypeId',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'data.transactionType',
        labelTranslationKey: 'TourData.TransactionType',
        required: false,
        cellAlign: 'right',
        default: false
    },
    {
        fieldName: 'data.createdOn',
        labelTranslationKey: 'TourData.CreatedOn',
        required: false,
        default: false,
        cellRender: v => <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>,
        printExportRender: v => moment(v).format(t("Common.DateTimeFormat"))
    },
    {
        fieldName: 'data.modifiedOn',
        labelTranslationKey: 'TourData.ModifiedOn',
        required: false,
        default: false,
        cellRender: v => <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>,
        printExportRender: v => moment(v).format(t("Common.DateTimeFormat"))
    },
    {
        fieldName: 'data.transportRefNumber',
        labelTranslationKey: 'TourData.TransportRefNumber',
        required: true,
        cellAlign: 'right',
        default: false
    },
    {
        fieldName: 'data.contractorNameShort',
        labelTranslationKey: 'TourData.ContractorNameShort',
        required: false
    },
    {
        fieldName: 'data.licensePlate',
        labelTranslationKey: 'TourData.LicensePlate',
        required: false,
        default: false
    }, /*{
        fieldName: 'data.notesExternal',
        labelTranslationKey: 'TourData.NotesExternal',
        required: false,
        default: false
    }, {
        fieldName: 'data.flowDirection',
        labelTranslationKey: 'TourData.FlowDirection',
        required: false,
        default: false,
    },*/
    {
        fieldName: 'data.transporterNameShort',
        labelTranslationKey: 'TourData.TransporterNameShort',
        required: false
    },
    /*
    {
        fieldName: 'data.itemId',
        labelTranslationKey: 'TourData.ItemId',
        required: false
    },
    */
    {
        fieldName: 'data.itemNumber',
        labelTranslationKey: 'TourData.ItemNumber',
        required: false,
        default: false
    },
    {
        fieldName: 'data.itemName',
        labelTranslationKey: 'TourData.ItemName',
        required: false
    },
    {
        fieldName: 'data.itemNameShort',
        labelTranslationKey: 'TourData.ItemNameShort',
        required: false,
        default: false
    },
    {
        fieldName: 'data.bestand1',
        labelTranslationKey: 'TourData.Bestand1',
        required: true,
        default: true
    },{
        fieldName: 'data.bestand2',
        labelTranslationKey: 'TourData.Bestand2',
        required: true,
        default: true
    },{
        fieldName: 'data.bestand3',
        labelTranslationKey: 'TourData.Bestand3',
        required: true,
        default: true
    },{
        fieldName: 'data.bestand4',
        labelTranslationKey: 'TourData.Bestand4',
        required: true,
        default: true
    },{
        fieldName: 'data.bestand5',
        labelTranslationKey: 'TourData.Bestand5',
        required: true,
        default: true
    },
    {
        fieldName: 'data.quantity',
        labelTranslationKey: 'TourData.Quantity',
        required: false
    }
];

const DEFAULT_COLUMNS = COLUMNS.filter(c => c.default).map(c => c.fieldName);

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const TourDataAvalanche = (props: RouteComponentProps<any> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & AdditionalDataServiceComponentProps & ViewSettingsComponentProps) => {

    const accounts = authService.principal.accounts.map(acc => acc.account);

    const props_data = props.data;
    const ltHeader: string|null = useMemo<string|null>(
        () => {

            let itemSetNumber = null;

            for (let i=0; i<props_data.length; i++) {

                if (itemSetNumber === null) {
                    itemSetNumber = props_data[i].data.itemSetNumber;
                } else {
                    if (itemSetNumber !== props_data[i].data.itemSetNumber) {
                        return null;
                    }
                }
            }

            return itemSetNumber;
        }, [props_data]
    );

    const getStockCaption = useCallback((id: number) => {

        if (ltHeader === null) {
            return t("TourData.Bestand"+ id);
        }

        if (props_data != null) {
            return _get(props_data, '0.data.itemNameShort' + id, '---');
        }
        return '---';
    }, [ltHeader, props_data]);

    const props_filter = props.filterObject.filter;
    const shouldAccountsSwitch = useCallback((r: any) => {
        return accounts.includes(r.data.depotNumberCounterpart) ||
            (props_filter && props_filter.filter !== "" &&
                r.data.depotNumberCounterpart.endsWith(props_filter)
                //r.data.depotNumberCounterpart.contains(props_filter) */
            );
    }, [props_filter, accounts]);

    const COLUMNS: ColumnDefinition[] = useMemo(() => [
        {
            fieldName: 'data.dateTransaction',
            labelTranslationKey: 'TourData.TourDate',
            required: false,
            default: true,
            cellRender: v => <Moment format={t("Common.DateFormat")}>{v}</Moment>,
            printExportRender: v => moment(v).format(t("Common.DateFormat"))
        },
        /*
        {
            fieldName: 'data.transactionId',
            labelTranslationKey: 'TourData.TransactionId',
            required: false,
            default: false
        },
         */
        {
            fieldName: 'data.transactionNumber',
            labelTranslationKey: 'TourData.TransactionNumber',
            required: false,
            default: true
        },
        {
            fieldName: 'data.contractorNumber',
            labelTranslationKey: 'TourData.ContractorNumber',
            required: false,
            default: true
        },
        {
            fieldName: 'data.contractorName',
            labelTranslationKey: 'TourData.ContractorName',
            required: false,
            default: false
        },
        {
            fieldName: 'data.depotNumber',
            labelTranslationKey: 'TourData.DepotNumber',
            required: false,
            default: true,
            cellRender: (v,r) => shouldAccountsSwitch(r) ? r.data.depotNumberCounterpart + ", " + r.data.depotNameCounterpart : r.data.depotNumber + ", " + r.data.depotName,
            printExportRender: (v,r) => shouldAccountsSwitch(r) ? r.data.depotNumberCounterpart + ", " + r.data.depotNameCounterpart : r.data.depotNumber + ", " + r.data.depotName,
        },
        {
            fieldName: 'data.depotNumberCounterpart',
            labelTranslationKey: 'TourData.DepotNumberCounterpart',
            required: false,
            default: true,
            cellRender: (v,r) => shouldAccountsSwitch(r) ? r.data.depotNumber + ", " + r.data.depotName : r.data.depotNumberCounterpart + ", " + r.data.depotNameCounterpart,
            printExportRender: (v,r) => shouldAccountsSwitch(r) ? r.data.depotNumber + ", " + r.data.depotName : r.data.depotNumberCounterpart + ", " + r.data.depotNameCounterpart,
        },
        {
            fieldName: 'data.transactionFileNumber',
            labelTranslationKey: 'TourData.TransactionFileNumber',
            required: false,
            default: true
        },
        {
            fieldName: 'data.transporterNumber',
            labelTranslationKey: 'TourData.TransporterNumber',
            required: false,
            default: true
        },
        {
            fieldName: 'data.transporterName',
            labelTranslationKey: 'TourData.TransporterName',
            required: false,
            default: true
        },
        {
            fieldName: 'data.documentNumber',
            labelTranslationKey: 'TourData.DocumentNumber',
            required: false,
            default: false
        },
        {
            fieldName: 'data.transactionFlowTypeNumber',
            labelTranslationKey: 'TourData.TransactionFlowTypeNumber',
            required: false,
            cellAlign: 'right',
        },
        {
            fieldName: 'data.transactionFlowTypeName',
            labelTranslationKey: 'TourData.TransactionFlowTypeName',
            required: false,
            cellAlign: 'right',
            default: false
        },
        {
            fieldName: 'data.statusId',
            labelTranslationKey: 'TourData.StatusId',
            required: false,
            cellAlign: 'right'
        },
        {
            fieldName: 'data.status',
            labelTranslationKey: 'TourData.Status',
            required: false,
            cellAlign: 'right',
            default: false
        },
        {
            fieldName: 'data.transactionTypeId',
            labelTranslationKey: 'TourData.TransactionTypeId',
            required: false,
            cellAlign: 'right'
        },
        {
            fieldName: 'data.transactionType',
            labelTranslationKey: 'TourData.TransactionType',
            required: false,
            cellAlign: 'right',
            default: false
        },
        {
            fieldName: 'data.createdOn',
            labelTranslationKey: 'TourData.CreatedOn',
            required: false,
            default: false,
            cellRender: v => <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>,
            printExportRender: v => moment(v).format(t("Common.DateTimeFormat"))
        },
        {
            fieldName: 'data.modifiedOn',
            labelTranslationKey: 'TourData.ModifiedOn',
            required: false,
            default: false,
            cellRender: v => <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>,
            printExportRender: v => moment(v).format(t("Common.DateTimeFormat"))
        },
        {
            fieldName: 'data.transportRefNumber',
            labelTranslationKey: 'TourData.TransportRefNumber',
            required: false,
            cellAlign: 'right',
            default: false
        },
        {
            fieldName: 'data.contractorNameShort',
            labelTranslationKey: 'TourData.ContractorNameShort',
            required: false
        },
        {
            fieldName: 'data.licensePlate',
            labelTranslationKey: 'TourData.LicensePlate',
            required: false,
            default: false
        },
        /*{
            fieldName: 'data.notesExternal',
            labelTranslationKey: 'TourData.NotesExternal',
            required: false,
            default: false
        },
        {
            fieldName: 'data.flowDirection',
            labelTranslationKey: 'TourData.FlowDirection',
            required: false,
            default: false,
            cellRender: (v,r) => (shouldAccountsSwitch(r) && v==="out" ? "in" : "out" )|| v,
            printExportRender: (v,r) => (shouldAccountsSwitch(r) && v==="out" ? "in" : "out" )|| v,
        },*/
        {
            fieldName: 'data.transporterNameShort',
            labelTranslationKey: 'TourData.TransporterNameShort',
            required: false
        },
        /*
        {
            fieldName: 'data.itemId',
            labelTranslationKey: 'TourData.ItemId',
            required: false
        },
        */
        {
            fieldName: 'data.itemSetNumber',
            labelTranslationKey: 'TourData.ItemNumber',
            required: false,
            default: false
        },
        {
            fieldName: 'data.itemSetName',
            labelTranslationKey: 'TourData.ItemName',
            required: false
        },
        {
            fieldName: 'data.itemSetNameShort',
            labelTranslationKey: 'TourData.ItemNameShort',
            required: false,
            default: false
        },
        {
            fieldName: 'data.bestand1',
            labelTranslationKey: 'TourData.Bestand1',
            required: true,
            default: true,
            label: getStockCaption(1),
            cellRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
            printExportRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
        },{
            fieldName: 'data.bestand2',
            labelTranslationKey: 'TourData.Bestand2',
            required: true,
            default: true,
            label: getStockCaption(2),
            cellRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
            printExportRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
        },{
            fieldName: 'data.bestand3',
            labelTranslationKey: 'TourData.Bestand3',
            required: true,
            default: true,
            label: getStockCaption(3),
            cellRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
            printExportRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
        },{
            fieldName: 'data.bestand4',
            labelTranslationKey: 'TourData.Bestand4',
            required: true,
            default: true,
            label: getStockCaption(4),
            cellRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
            printExportRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
        },{
            fieldName: 'data.bestand5',
            labelTranslationKey: 'TourData.Bestand5',
            required: true,
            default: true,
            label: getStockCaption(5),
            cellRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
            printExportRender: (v,r) => shouldAccountsSwitch(r) && v ? (v * -1) : v,
        },
        {
            fieldName: 'data.quantity',
            labelTranslationKey: 'TourData.Quantity',
            required: false
        }
    ], [getStockCaption, shouldAccountsSwitch]);

    const { filterObject, additionalData, handleFilterChange } = props;
    const { selectedDate } = filterObject || {};
    const { dates } = additionalData || {};
    
    useEffect(() => {
        if(!selectedDate) {
            console.log('No selected date, available: ', dates);
            if (dates && dates.length > 0) {
                handleFilterChange("selectedDate", new Date(dates[dates.length - 1]));
            } else if(dates && dates.length === 0) {
                // dates loaded, but is empty
                handleFilterChange("selectedDate", new Date());
            }
        }
    }, [selectedDate, dates, handleFilterChange]);

    ExportContextHolder.fields = COLUMNS.map(c => c.labelTranslationKey? t(c.labelTranslationKey) : c.label);
    ExportContextHolder.columns = COLUMNS;

    useEffect(() => {
        ExportContextHolder.reloadHeaderFunc();
    }, [COLUMNS]);

    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }

    if (!props.filterObject.selectedDate) {
        return <></>;
    }

    return (
        <>
            <AnalyticsTracking page="tourdata-avalanche" />
            <div className={"sticky-header"}>
                <div className={"ui container"}>

                    <h3><Breadcrumb icon="right angle" sections={[
                        {
                            key: '1',
                            as: NavLink,
                            to:  "/TourData-avalanche/",
                            content: `${t ("Route.TourDataAvalanche")}`,
                        }
                    ]} /></h3>

                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
                    <Grid columns={4} className={"HeadingGrid"} stackable={true}
                          style={{marginBottom: '1em'}}>
                        <Grid.Column  width={5}>
                            <InventoryAccountModal chooseFunc={(newFilter: any) => props.handleFilterChange('debtor', newFilter.trim())}/>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                                   value={props.filterObject.filter}
                                   onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <ColumnSelectionButton
                                fluid
                                availableColumns={COLUMNS}
                                selectedColumns={props.selectedColumns}
                                onSave={props.updateSelectedColumns}/>
                        </Grid.Column>
                        <Grid.Column width={1}>
                            <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                                <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>
            </div>

            <div className={"ui container responsivewrapper"}>
                <DataTable
                    columns={COLUMNS}
                    data={props.data}
                    page={props.page}
                    totalPages={props.totalPages}
                    sortDirection={props.sortDirection}
                    sortColumn={props.sortColumn}
                    selectedColumns={props.selectedColumns}
                    getScrollParent={getScrollParent}
                    loadMore={props.loadMore}
                    handleSortChange={props.handleSortChange}
                    loading={props.loading}
                    filter={props.filterObject}
                />
                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
        if (!GUARD_FEATURESWITCH_ENABLED("TourendatenAvalanche") && !GUARD_ADMIN())
            return new Promise((resolve,reject)=> resolve({"data": {"content": []}}));

        return  TourDataServiceSingleton.getAllTourDataAvalanche(sortColumn, sortOrder, page, 50, filter.filter ? filter.filter : "", filter.selectedDate ? filter.selectedDate : "", filter.debtor? filter.debtor : "");
    }
};

const  TourDataWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withAdditionalDataServices(withInfinityScrollHandlers(TourDataAvalanche))))))));

export default () => (
    <TourDataWrapped
        viewName="tourData"
        dataService={dataService}
        defaultSortDirection="DESC"
        defaultSortColumn="data.dateTransaction"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
            selectedDate: null
        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.TourData")}`]}
        dataToLoad={{
            dates: {
                uri: "/tour-data-avalanche/dates"
            }
        }}
    />
);